import type { SxProps } from '@mui/material';
import type { Theme } from 'hephaestus/core';
import { Box, Typography } from 'hephaestus/web';
import type { ReactElement } from 'react';
import { Trans } from 'react-i18next';
import { ExternalLink } from './1-primative/link/externalLink';

export const TransferErrorBanner = ({
  theme,
  i18nKey,
  values,
  supportUrl,
  linkSx,
  components,
  showHeader = true,
}: {
  theme: Theme;
  i18nKey: string;
  values?: Record<string, unknown>;
  supportUrl?: string;
  linkSx?: SxProps;
  components?: readonly ReactElement[] | Readonly<Record<string, ReactElement>>;
  showHeader?: boolean;
}) => (
  <Box
    sx={{
      mt: 2,
      backgroundColor: theme.color.negativeVariant,
      padding: '11px 16px 13px 16px',
      borderRadius: theme.borderRadius.md,
    }}
  >
    {showHeader && (
      <Typography
        variant='bodyMedium'
        sx={{ fontWeight: 600, mb: '4px', color: theme.color.negativeOutline }}
      >
        <Trans i18nKey='transfer:withdrawal.withdrawErrorHeader' />
      </Typography>
    )}
    <Typography variant='bodySmall' sx={{ color: theme.color.negativeOutline }}>
      <Trans
        i18nKey={i18nKey}
        values={values}
        components={
          components ?? [<ExternalLink key='0' href={supportUrl} sx={linkSx} />]
        }
      />
    </Typography>
  </Box>
);
